var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"layers pt-4"},[_c('layer-chooser',{on:{"select-layers":_vm.onSelectLayers,"remove-layers":_vm.onRemoveLayer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }